import React from 'react'
import EditPencilSVG from "../../../assets/icons/edit-pencil.svg"
export const EditPencilIcon: React.FC = () => {
  return (
    <img src={EditPencilSVG} alt="" className="w-[15px] h-[15px] cursor-pointer" />
  )
}
